var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row py-10 justify-center"},[_c('div',{staticClass:"raising-block"},[_c('div',{staticClass:"raising-block-top"},[_vm._v(_vm._s(_vm._f("currency")(_vm.amount,"$", 0)))]),_c('div',{staticClass:"raising-block-bottom"},[_vm._v(_vm._s(_vm.count)+" SOLD")]),_c('div',{staticClass:"raising-bottom-border"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }